export default __webpack_public_path__ + "static/media/Phone+.91450575.svg";